export default "__VITE_ASSET__BjkFDEi1__"